import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Center,
  Textarea,
  Checkbox,
  Image,
  Stack, 
  Link,// Importa la propiedad Grid
} from "@chakra-ui/react";
import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdFacebook,
  MdOutlineEmail,
} from "react-icons/md";
import { FaLocationArrow, FaWhatsapp, FaEnvelope, FaPhone, FaHouse, FaBuilding} from 'react-icons/fa'
import { COLORS } from "../../../colors";

export default function FormDemo() {
  return (
    <Container
      bg="white"
      maxW="full"
      mt={0}
      centerContent
      overflow="hidden"
      py={"3rem"}
    >
     <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} spacing={20}>
      <Flex flex={0.75} flexDirection="column" m={10}>
        <Link href="https://www.google.es/maps/place/Somerset+Language+Centre/@39.4864831,-0.3741703,16.67z/data=!4m6!3m5!1s0xd604601c1453a5f:0xe2ac12582f38d91a!8m2!3d39.4866863!4d-0.3716102!16s%2Fg%2F1pv2f2446?hl=es&entry=ttu">
          <Image
            alt={'Maps Image'}
            objectFit={'cover'}
            mt={15}
            mb={30}
            src={
            "/localizacion.png"
            }
          />
        </Link>
        <Flex flexDirection="column" gap={3} mb={10}>
          <Text textAlign="center" color="black" fontFamily="Montserrat">
              Calle Ministro Luis Mayans, 31 Bajo
          </Text>
          <Link fontSize={"sm"} textAlign="center" href="https://api.whatsapp.com/send?phone=601129552">601 12 95 52</Link>
          <Link href="tel:+34963388933" fontSize={'sm'} textAlign="center">963 38 89 33</Link>
          <Link href="mailto:info@somersetlc.com" fontSize={'sm'} textAlign="center">info@somersetlc.com</Link>
        </Flex>
      </Flex>
     

      
        <Flex  flexDirection="column" m={10}> 
        <Heading textAlign={"center"} as="h2" size="xl" mb={0} fontFamily={"Montserrat"} color="black">¡Pregúntanos!</Heading>
        <Flex flexDirection={'column'} gap={10} m={50}>
            
            <Button                
                //to="mailto:info@somersetlc.com"
                size={"md"}
                fontWeight={"normal"}
                px={6}
                border={`2px solid ${COLORS.brand1}`}
                bg={COLORS.brand5}
                color={COLORS.brand1}
                _hover={{ bg: COLORS.brand1, color: COLORS.brand5}}
                fontFamily={"Montserrat"}
                onClick={() => window.location.href = 'mailto:info@somersetlc.com'}
                

            >
                Contactar por e-mail
            </Button>
        
        <Button           
            onClick={() => window.location.href = "https://api.whatsapp.com/send?phone=601129552"}
            size={"md"}
            fontWeight={"normal"}
            px={6}
            border={`2px solid ${COLORS.brand1}`}
            bg={COLORS.brand5}
            color={COLORS.brand1}
            _hover={{ bg: COLORS.brand1, color: COLORS.brand5}}
            fontFamily={"Montserrat"}
        >
            Contactar por Whatsapp
        </Button>
  </Flex>

  
  {/*          <Box p={10}>
              <Wrap spacing={{ base: 5, sm: 3, md: 5, lg: 10 }}>
                <WrapItem>
                  <Box bg={{ base: "white" }} borderRadius="lg">
                    <Box m={3} color="#0B0E3F" fontFamily={"Montserrat"}>
                      <VStack spacing={5}>
                        <HStack spacing={5}>
                        <FormControl id="name">
                          <FormLabel>Nombre y apellidos</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <Input type="text" size="md" placeholder="Nombre y apellidos" bgColor={"white"} />
                          </InputGroup>
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel>Correo electrónico</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <Input type="text" size="md" placeholder="Correo electrónico" bgColor={"white"} />
                          </InputGroup>
                        </FormControl>
                        </HStack>
                        <FormControl id="name">
                          <FormLabel>Mensaje</FormLabel>
                          <Textarea
                            bgColor={"white"}
                            borderColor="gray.300"
                            _hover={{
                              borderRadius: "gray.300",
                            }}
                            placeholder="Mensaje"
                          />
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel><Checkbox colorScheme="green">Acepto la política de privacidad</Checkbox></FormLabel>
                        </FormControl>
                        <FormControl id="name" float="right">
                          <Center>
                            <Button
                              variant="solid"
                              bg={COLORS.brand1}
                              color={COLORS.brand4}
                              _hover={{ bg: COLORS.brand3, color: COLORS.brand1}}
                            >
                              Enviar
                            </Button>
                          </Center>
                        </FormControl>
                      </VStack>
                    </Box>
                  </Box>
                </WrapItem>
              </Wrap>
            </Box>*/}
        </Flex> 
      </Stack>  
    </Container>

                          
  );
}
